import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '..'

const AddPlus = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#clip0_1820_266)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9 21c2.06.12 4.13.12 6.19 0 2.87-.21 5.69-3.02 5.9-5.9.12-2.06.12-4.13 0-6.19-.21-2.87-3.02-5.69-5.9-5.9-2.06-.12-4.13-.12-6.19 0-2.87.21-5.69 3.02-5.9 5.9-.12 2.06-.12 4.13 0 6.19.21 2.87 3.02 5.69 5.9 5.9zm4-9.9h2.33c.5 0 .9.4.9.9s-.4.9-.9.9H12.9v2.33c0 .5-.4.9-.9.9s-.9-.4-.9-.9V12.9H8.77c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h2.33V8.77c0-.5.4-.9.9-.9s.9.4.9.9v2.33z"
        fill="#000"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1820_266">
        <Path fill="#fff" d="M0 0H24V24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default AddPlus
